<template lang="pug">
    .slide(v-if="image" :style="{ height: `${height}px` }")
      figure
        // TODO: fix lazy loading
        // see: src/extensions/shop/components/CategoryProducts/Teaser.vue
        img(
          v-lazy="image"
          :style="{ width: `${width}px`, height: `${height}px` }"
          rel="noopener"
        )
      .content(v-if="slide.title || slide.sub_title || slide.text" ref="content")
        h2(v-if="slide.title") {{ slide.title }}
        h4(v-if="slide.sub_title") {{ slide.sub_title }}
        .text(v-if="slide.text" v-html="slide.text")
        router-link.more-link(
          v-if="path"
          :to="path"
        )
          | {{ linkText }}
        component.more-link(
          v-else-if="href"
          :is="tag"
          v-bind="props"
        )
          | {{ linkText }}
</template>

<script>
import { get, trim } from '@/helpers';

export default {
  name: 'Slide',
  data() {
    return {
      delay: 0,
      mouseover: false
    };
  },
  props: {
    slide: {
      type: Object,
      required: true
    },
    maxWidth: {
      type: Number,
      required: true
    },
    maxHeight: {
      type: Number,
      required: true
    }
    // imageLoaded: {
    //     type: Boolean,
    //     default: false,
    // }
  },
  computed: {
    tag() {
      let tag = 'div';
      if (this.path) tag = 'router-link';
      else if (this.href) tag = 'a';
      return tag;
    },
    props() {
      let props = {};

      switch (this.tag) {
        case 'router-link':
          props.to = this.path;
          break;

        case 'a':
          props.title = this.slide.title || this.slide.sub_title;
          props.href = this.href;
          props.target = this.target;
          break;
      }

      return props;
    },
    image() {
      const image = get(this.slide, 'images.0');
      if (!image) return false;

      if (!this.maxWidth || !this.maxHeight) return false;

      let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1';
      const parameters = {
        ...get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
        ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups')
      };
      // let { w, h, fx, fy, fz } = parameters;
      let { fx, fy, fz } = parameters;

      let width, height, aspectRatio;

      width = image.width / fz;
      height = image.height / fz;
      aspectRatio = width / height;

      // // height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height);
      // // width = height * aspectRatio;
      //
      // if (maxWidth < width) {
      //   height = maxWidth / aspectRatio;
      //   height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height);
      //   width = height * aspectRatio;
      // }

      // if (w && h) {
      //   aspectRatio = w / h;
      //
      //   height = Math.min(window.innerWidth >= 1088 ? 400 : 140, image.height / fz);
      //   width = height * aspectRatio;
      //
      //   if (this.maxWidth < width) {
      //     height = this.maxWidth / aspectRatio;
      //     height = Math.min(window.innerWidth >= 1088 ? 400 : 140, image.height / fz);
      //     width = height * aspectRatio;
      //   }
      //
      //   fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`);
      // } else if (!w && !h) {
      //   fit += `&h=${height}`;
      // }

      if (!fx) fx = 0.5;
      if (!fy) fy = 0.5;
      if (!fz) fz = 1;

      // fit: cover

      width = this.maxWidth;
      height = this.maxHeight;
      aspectRatio = width / height;

      fit = `fit=crop&crop=focalpoint&x=${fx}&y=${fy}&z=${fz}&w=${width}&h=${height}`;

      // TODO:
      // fit: contain

      const storageRoute = trim(
        `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        '/'
      );

      return {
        src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
        error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
        width,
        height,
        aspectRatio
      };
    },
    width() {
      if (this.image.width) return Math.min(this.maxWidth, this.image.width);
      else return undefined;
    },
    height() {
      if (this.width && this.image.aspectRatio) return this.width / this.image.aspectRatio;
      else return undefined;
    },
    hyperlink() {
      return get(this.slide, 'hyperlink') || {};
    },
    href() {
      let href = false;

      if (this.hyperlink.type !== 'internal' && get(this.hyperlink, 'href')) {
        const link = this.hyperlink.href;
        switch (this.hyperlink.type) {
          case 'external':
            if (!link.startsWith('https://') && !link.startsWith('http://')) href = `https://${link}`;
            else href = link;
            break;

          case 'mailto':
            href = `mailto:${link}`;
            break;

          case 'tel':
            href = `tel:${link}`;
            break;
        }
      }

      return href;
    },
    target() {
      return get(this.hyperlink, 'target') || '_self';
    },
    path() {
      if (this.hyperlink.type === 'internal' && get(this.hyperlink, 'menuItem.path'))
        return this.hyperlink.menuItem.path;
      else return false;
    },
    linkText() {
      return get(this.hyperlink, 'name') || 'mehr...';
    },
    style() {
      let style = {};

      if (this.slide.color) {
        style.background = this.slide.color;
      }

      return style;
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.slide
  display: flex
  justify-content: center
  align-items: center

figure
  position: absolute
  left: 0
  top: 0
  width: 100%
  height: 100%
  img
    object-fit: cover

.content
  width: 400px
  text-decoration: none
  max-width: calc(100vw - 2rem)
  padding: .8rem 1.6rem
  background: rgba($black, .4)
  backdrop-filter: blur(10px)
  border-radius: .4rem
  color: $white
  margin-top: 1rem
  margin-bottom: 1rem
  @screen md
    width: 600px
  @screen xl
    width: 800px
  h2
    font-size: 1.4rem
    font-weight: 600
    @screen md
      font-size: 1.8rem
      font-weight: 500
  h4
    font-weight: 600
    @screen md
      font-size: 1.2rem
      font-weight: 500
  a
    color: theme('colors.blue.300')
  .text
    margin-top: .8rem
</style>
